import { render, staticRenderFns } from "./BankAccountBody.vue?vue&type=template&id=390b5a84&scoped=true&"
import script from "./BankAccountBody.vue?vue&type=script&lang=ts&"
export * from "./BankAccountBody.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccountBody.vue?vue&type=style&index=0&id=390b5a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b5a84",
  null
  
)

export default component.exports